<template>
  <extract-offer-details />
</template>
<script>
import ExtractOfferDetails from './components/ExtractOfferDetails.vue';
export default {
  components: {
    ExtractOfferDetails
  },
  data: function() {
    return {
      animation: {
        smTop: '-5px',
        smWidth: '110px',
        width: 240,
        height: 240,
        smHeight: 110,
        smWidth: 110
      },
      helpText: 'It helps us personalize your ads'
    };
  }
}
</script>